import { render } from "./home-section.vue?vue&type=template&id=298b69b0&lang=pug"
import script from "./home-section.vue?vue&type=script&setup=true&lang=js"
export * from "./home-section.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__